import { repository } from 'aurelia-orm';
import { ItemTypeBase } from "./item-type-base";


@repository(EntityStatus)
export class EntityStatus extends ItemTypeBase {
   
}